import { render } from "./coupon-list.vue?vue&type=template&id=3a0221ba&scoped=true&ts=true"
import script from "./coupon-list.vue?vue&type=script&lang=ts"
export * from "./coupon-list.vue?vue&type=script&lang=ts"

import "./coupon-list.vue?vue&type=style&index=0&id=3a0221ba&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0221ba"]])

export default __exports__